import { Schema } from "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";
import { BaseExtension } from "@/wc/text-editor/lib/core/base-extension";
import { LinkPreviewPopup } from "./component/link-preview";
import { useLinkPreview } from "@/composables/link-preview";

import { POPUP_MANAGER_PLUGIN } from "@/wc/text-editor/lib/core/popups";

const LINK_PREVIEW_PLUGIN = new PluginKey("LINK_PREVIEW_PLUGIN");

export class LinkPreviewExtension extends BaseExtension {
    popupKey = "LINK_PREVIEW";

    modifySchema = (currentSchema: Schema) => {
        return new Schema({
            nodes: currentSchema.spec.nodes,
            marks: currentSchema.spec.marks.update("link", {
                ...currentSchema.marks.link.spec,
                attrs: {
                    ...currentSchema.marks.link.spec.attrs,
                    popupKey: { default: this.popupKey },
                    popupHover: { default: true },
                },
            }),
        });
    };

    plugins = () => {
        const linkPreviewPlugin = new Plugin({
            key: LINK_PREVIEW_PLUGIN,
            props: {
                decorations: (state) => {
                    return LINK_PREVIEW_PLUGIN.getState(state)!;
                },
            },
            view: (view) => {
                const popupManagerState = POPUP_MANAGER_PLUGIN.getState(
                    view.state
                );
                if (!popupManagerState) return {};

                popupManagerState.handlers[this.popupKey] = (
                    node,
                    cursor,
                    mark
                ) => {
                    return {
                        startPos: cursor.startPos,
                        endPos: cursor.endPos,
                        onlyInEditMode: false,
                        onlyInViewMode: true,
                        create: async () => {
                            if (!mark?.attrs.href) return;
                            const { get } = useLinkPreview();
                            return new LinkPreviewPopup({
                                href: mark.attrs.href,
                                getLinkPreview: get(mark.attrs.href),
                            });
                        },
                        node,
                        closeOnMouseLeave: true,
                    };
                };

                return {};
            },
        });
        return [linkPreviewPlugin];
    };
}
